import React from "react";
import "./Slider.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";

const ImageSlider = ({ images }) => {
  const navigate = useNavigate()
  const imageDimensions = {
    width: window.innerWidth > 768 ? 700 : 500,
    height: window.innerWidth > 768 ? 450 : 250,
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    prevArrow: null,
    nextArrow: null,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  const handleImageClick = () => {
    navigate("/gallery", { state: { images } });
  };

  return (
    <>
      <Slider {...settings}>
        {images.map((image, index) => (
          <div
            key={index}
            className="productImgGallery"
            style={{ borderRadius: "20px", overflow: "hidden" }}
            onClick={handleImageClick}
          >
            <img
              src={image.file}
              alt={`Product Image ${index}`}
              style={{
                width: imageDimensions.width,
                height: imageDimensions.height,
                borderRadius: "20px",
                zIndex: 9999,
              }}
            />
          </div>
        ))}
      </Slider>
    </>
  );
};

export default ImageSlider;
